import { Reducer } from "redux";

import { ResendEmailResponse } from "../models/Api/Document";
import { ResendEmailDispatchTypes } from "../models/DispatchTypes/Document";
import { ResendEmailActionDispatchTypes } from "../constants/Document";

const initialState: ResendEmailResponse = {
  loading: false,
    response: {
        referralId: 0,
        authorizationNumber: "",
        patientFirstName: "",
        patientLastName: "",
        emailAddresses: "",
        emailAttachmentBlobId: 0,
        emailStatus: "",
    },
  error: null,
};

const ResendEmailReducer: Reducer<
    ResendEmailResponse,
    ResendEmailDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ResendEmailReducer;
